export default __webpack_public_path__ + "static/media/icon-remove-color-red.3c662b75.png";